import React, { useEffect } from "react";

import TitledDialog from "./TitledDialog";
import descriptors, { ResourceName } from "../descriptors";
import { FormattedMessage, useIntl } from "react-intl";
import { Alert, Button, Stack } from "@mui/material";
import { fetchRead, submitDelete } from "../utils/crud";
import { useFetch } from "./FetchProvider";
import Loading from "./Loading";
import { useNotification } from "./NotificationProvider";

const Identifiers: React.FC<{
    resourceName: ResourceName;
    data: any;
}> = ({ resourceName, data }) => {
    const descriptor = descriptors[resourceName];
    const renderers = descriptor.renderers?.delete;
    console.log("rendereres", renderers);
    console.log("identifiers", descriptor.identifiers);
    console.log("data", data);

    const rows = [];
    for (const name of descriptor.identifiers) {
        console.log("id", name);
        const content = renderers && name in renderers ? renderers[name](data[name], data) : data[name];
        console.log("content", content);
        rows.push(
            <tr>
                <td>
                    <FormattedMessage id={`${resourceName}.${name}`} />
                </td>
                <td>{content}</td>
            </tr>,
        );
    }

    return (
        <table>
            <tbody>{...rows}</tbody>
        </table>
    );
};

const DeleteConfirm: React.FC<{
    resourceName: ResourceName;
    id: number;
    onSuccess?: () => void;
}> = ({ resourceName, id, onSuccess }) => {
    const fetch = useFetch();
    const [data, setData] = React.useState<any | null>(null);
    const intl = useIntl();
    const { showSuccess } = useNotification();

    useEffect(() => {
        fetchRead(fetch, resourceName, id, false).then((data) => {
            setData(data);
        });
    }, [id, resourceName]);

    if (data === null) return <Loading />;

    const submit = async () => {
        console.log("submit delete");
        await submitDelete(fetch, resourceName, id);
        const notificationName = intl.formatMessage({ id: `${resourceName}.notificationName` });
        showSuccess(
            <FormattedMessage id="resource_deleted" values={{ notificationName }} />,
            <FormattedMessage id="notification.success" />,
        );
        onSuccess();
    };

    return (
        <Stack spacing={2}>
            <Alert severity="warning">
                <FormattedMessage id="crud.delete.confirm" />
            </Alert>
            <Identifiers resourceName={resourceName} data={data} />
            <Button onClick={submit} color="primary">
                <FormattedMessage id="crud.delete.delete" />
            </Button>
        </Stack>
    );
};

/// a dialog that ask for confirmation before deleting a resource
const DeleteResourceDialog: React.FC<{
    open: boolean; /// if the dialog should be shown
    hide: () => void; /// hide the dialog - should set the open state to false
    resourceName: ResourceName;
    id: number; /// the id of the resource to be updated when action is update
    onSuccess?: () => void; /// do stuff if the form submit is successful - like revalidate the data
}> = ({ open, hide, resourceName, id, onSuccess }) => {
    if (!open) return null;

    return (
        <TitledDialog title={`${resourceName}.delete`} open={open} hide={hide} isContentChanged={() => false}>
            <DeleteConfirm resourceName={resourceName} id={id} onSuccess={onSuccess} />
        </TitledDialog>
    );
};

export default DeleteResourceDialog;
